import { render, staticRenderFns } from "./AttributeStats.vue?vue&type=template&id=c4e2c044&"
import script from "./AttributeStats.vue?vue&type=script&lang=js&"
export * from "./AttributeStats.vue?vue&type=script&lang=js&"
import style0 from "./AttributeStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports